import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'

export const BankMasterPopup = (props) => {
    // console.log('list', props.bankMaster.aCCSubHeadList)
    // console.log('id', props.bankMaster.idGeneralProduct)
    return (
        <ModalBasic
            id="companyMaster"
            classParams="!w-[75%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Account details</span>
                <div className='item-grp grid grid-cols-3 gap-2.5 mt-[12px]'>
                    <div className='input-grp'>
                        <label>Acc. sub head:</label>
                        <MultiSelectDropdown
                            drpIdentity="Acc sub head"
                            options={props.bankMaster.aCCSubHeadList}
                            value={props.bankMaster.idGeneralProduct ? props.bankMaster.aCCSubHeadList.find(x => x.value === props.bankMaster.idGeneralProduct) : 0}
                            onChange={(event) =>
                                props.handleChange(event, "GeneralProduct")
                            }
                            className={` ${props.validState?.error?.idGeneralProduct ? "error" : ""}`}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Account name:</label>
                        <TextInput type='text'
                            id='accName' name='accName'
                            value={props.bankMaster.accName}
                            handleChange={(event) => props.handleChange(event, 'accName')}
                            className={` ${props.validState?.error?.accName ? "error" : ""}`}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Bank group:</label>
                        <TextInput type='text'
                            id='bankGrp' name='bankGrp'
                            value={props.bankMaster.bankGrp}
                            handleChange={(event) => props.handleChange(event, 'bankGrp')}

                        />
                    </div>
                    <div className='input-grp'>
                        <label>Opening balance date:</label>
                        <TextInput type='date'
                            id='openingBalanceDate' name='openingBalanceDate'
                            value={props.bankMaster.openingBalanceDate}
                            handleChange={(event) => props.handleChange(event, 'openingBalanceDate')}
                            className={` ${props.validState?.error?.openingBalanceDate ? "error" : ""}`}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Opening balance:</label>
                        <TextInput type='number'
                            id='openingBalance' name='openingBalance'
                            value={props.bankMaster.openingBalance}
                            handleChange={(event) => props.handleChange(event, 'openingBalance')}
                            className={` ${props.validState?.error?.openingBalance ? "error" : ""}`}
                        />
                    </div>

                    <div className='input-grp'>
                        <label>Balance type:</label>
                        <MultiSelectDropdown
                            drpIdentity="Balance type"
                            options={props.bankMaster.types}
                            value={props.bankMaster.types.find(x => x.value === props.bankMaster.balanceTypeId)}
                            onChange={(event) =>
                                props.handleChange(event, "balanceType")
                            }
                            className={` ${props.validState?.error?.balanceTypeId ? "error" : ""}`}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Current balance:</label>
                        <TextInput type='number'
                            id='currentBalance' name='currentBalance'
                            value={props.bankMaster.openingBalance}
                            //handleChange={(event) => props.handleChange(event, 'openingBalanceDate')}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks:</label>
                        <textarea rows={1} type='text'
                            id='remarks' name='remarks'
                            value={props.bankMaster.remarks}
                            onChange={(event) => props.handleChange(event, 'remarks')}
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()} >Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}
